'use strict';

module.exports = function (Molecule) {
    var fields = new Map();

    fields.set('oclid', Molecule.fromIDCode);
    fields.set('idcode', Molecule.fromIDCode);
    fields.set('smiles', Molecule.fromSmiles);
    fields.set('molfile', Molecule.fromMolfile);

    return fields;
};


//////////////////
// WEBPACK FOOTER
// ./~/openchemlib-extended/lib/db/moleculeCreators.js
// module id = 43
// module chunks = 0